import React from 'react';

const Footer = () => {
  return (
    <footer className="modern-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Aminole</h3>
            <p>Learn amino acids through interactive gameplay</p>
            <div className="footer-logo">
              <img src={`${process.env.PUBLIC_URL}/assets/images/Aminole-Logo.png`} alt="Aminole Logo" className="footer-logo-img" />
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Learn</h4>
            <ul>
              <li><a href="#game">Play Game</a></li>
              <li><a href="#guide">How to Play</a></li>
              <li><a href="#amino-acids">Amino Acid Guide</a></li>
              <li><a href="#tips">Study Tips</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Support</h4>
            <ul>
              <li><a href="#help">Help Center</a></li>
              <li><a href="https://docs.google.com/forms/d/e/1FAIpQLSfnV0YtjIqmYou9ib5b8mkbSNNqBsb_vIJni1DUdAT-tpylJw/viewform?usp=header" target="_blank" rel="noopener noreferrer">Send Feedback</a></li>
              <li><a href="#bug-report">Report Bug</a></li>
              <li><a href="#contact">Contact Us</a></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-team-section">
          <h4>Our Team</h4>
          <div className="team-members">
            <a href="https://www.clemson.edu/science/academics/departments/genbio/about/profiles/heidid" target="_blank" rel="noopener noreferrer">Dr. Heidi Anderson</a>
            <a href="https://www.linkedin.com/in/cooper-gill-0b1103246/" target="_blank" rel="noopener noreferrer">Cooper Gill</a>
            <a href="https://www.linkedin.com/in/alyssa-jones-6810b1342/" target="_blank" rel="noopener noreferrer">Alyssa Jones</a>
            <a href="https://www.linkedin.com/in/sydney-kaminsky/" target="_blank" rel="noopener noreferrer">Sydney Kaminsky</a>
            <span>Jaiden Poole</span>
            <a href="https://www.linkedin.com/in/davis-katz/" target="_blank" rel="noopener noreferrer">Davis Katz</a>
            <a href="https://www.linkedin.com/in/janie-mcdonald-886706280/" target="_blank" rel="noopener noreferrer">Janie McDonald</a>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="project-info">
              <span>Clemson University Creative Inquiry Project 2025</span>
            </div>
            <div className="location">
              <span className="location-icon">📍</span>
              <span className="location-text">Clemson, SC</span>
            </div>
            <div className="footer-links">
              <a href="#privacy">Privacy Policy</a>
              <span className="separator">•</span>
              <a href="#terms">Terms of Use</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
